import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import route from "../../../../assets/icons/route.svg";
import clock from "../../../../assets/icons/Clock.svg";
import deviation from "../../../../assets/icons/Deviation.svg";
import check from "../../../../assets/icons/check.svg";
import infoIcon from "../../../../assets/icons/i.svg";
import { IconButton } from "@mui/material";

const TripDetailsTiles = ({ tripDetails }: { tripDetails: any }) => {
    const [tripTilesData, setTripTilesData] = useState<any>()
    const formatDate = (dateString: any) => {
        if (!dateString) return "";
        const formattedDateString = dateString.replace(":", "T");
        const date = new Date(formattedDateString);
        if (isNaN(date.getTime())) return "Invalid Date";
        const options: any = { day: "numeric", month: "short", year: "numeric" };
        let formattedDate = date.toLocaleDateString("en-GB", options);
        const day = date.getDate();
        const suffix = ["st", "nd", "rd"][(day % 10) - 1] || "th";
        formattedDate = formattedDate.replace(/(\d+)/, `$1${suffix}`);

        return formattedDate;
    };
    useEffect(() => {
        setTripTilesData([
            {
                icon: route,
                heading: "Trip completion",
                value: tripDetails?.tripCards?.tripCompleted,
            },
            {
                icon: clock,
                heading: "Total Alerts",
                value: tripDetails?.tripCards?.alertCount,
            },
            {
                icon: deviation,
                heading: "Current Fuel levels",
                value: "0",
            },
            {
                icon: check,
                heading: "Estimated Arrival duration",
                value: formatDate(tripDetails?.tripCards?.tripEstimatedArrival),
            },
        ])
    }, [tripDetails])

    return (
        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {tripTilesData?.map((tile: any, index: any) => (
                <Paper
                    key={index}
                    sx={{ borderRadius: "12px" }}
                    className="border border-[#f0eff8] p-4 flex flex-col gap-1 items-start"
                >
                    <div className="flex items-center gap-2 w-full">
                        <IconButton sx={(theme) => ({
                            background: theme.palette.selected,
                            padding: '4px'
                        })}>

                            <img src={tile?.icon} alt="icon" color="primary" />
                        </IconButton>
                        <div className="flex flex-1 min-w-0 flex-col justify-start gap-1">
                            <Typography
                                variant="body2"
                                noWrap // Ensures text doesn't wrap and remains in a single line
                                sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    maxWidth: "100%" // Ensures it adapts to available space
                                }}
                            >
                                {tile.heading}
                            </Typography>
                        </div>

                        <img
                            src={infoIcon}
                            alt="info icon"
                            title="More info"
                            className="w-4 h-4 cursor-pointer"
                        />
                    </div>
                    <div className="flex items-center w-full gap-2 flex-nowrap">
                        <div className="invisible w-6 h-6">
                            {tile.icon}
                        </div>
                        <Typography
                            variant="h6"
                            fontWeight={600}
                            className="flex-grow px-2 w-full whitespace-nowrap overflow-hidden text-ellipsis"
                        >
                            {tile.value}
                        </Typography>
                    </div>
                </Paper>
            ))}
        </div>
    );
};

export default TripDetailsTiles;
